/* madeova · 邮件弹窗逻辑（v12 从 snippets/email-capture-popup.liquid 外置）
   外置原因：原为 60.8 KB 内联脚本，占商品页 HTML 的 8.8%，且阻塞解析。
   外置后：HTML 立即减小 60.8 KB；本文件独立可缓存；以 defer 加载不阻塞解析。
   本文件由 Liquid 抽取而来，内容逐字节等同于抽取前，不含任何 Liquid 模板语法。 */

  (function() {
    'use strict';
    
    // 配置
    var DISCOUNT_CODE = 'WOBBLE10';
    var STORAGE_KEY = 'madeova_discount_applied';
    var EMAIL_KEY = 'madeova_customer_email';
    var POPUP_DISMISSED_KEY = 'madeova_popup_dismissed'; // 用户关闭弹窗标记（会话级）
    
    // DOM元素（安全获取，避免null错误）
    var overlay = document.getElementById('emailPopupOverlay');
    var closeBtn = document.getElementById('emailPopupClose');
    var formContainer = document.getElementById('emailPopupFormContainer');
    var successContainer = document.getElementById('emailPopupSuccess');
    var form = document.getElementById('emailPopupCustomerForm');
    var emailInput = document.getElementById('emailPopupInput');
    var submitBtn = document.getElementById('emailPopupSubmitBtn');
    var couponCopyBtn = document.getElementById('couponCopyBtn');
    var continueShoppingBtn = document.getElementById('continueShoppingBtn');
    var directCheckoutBtn = document.getElementById('emailPopupDirectCheckoutBtn');
    var checkoutAfterDiscountBtn = document.getElementById('checkoutAfterDiscountBtn');
    var toast = document.getElementById('emailPopupToast');
    var privacyTextEl = document.querySelector('.email-popup-privacy');
    
    // 如果关键元素不存在，直接退出，不影响页面其他脚本
    if (!overlay || !form) {
      console.log('Email popup: required elements not found, exiting');
      return;
    }

    // ============================================
    // NO-FULL-POST 防线（2026-09-19）—— 本弹窗历史上最严重的体验事故
    // ============================================
    // 现象：客户填完邮箱点「Apply 10% Discount」，**页面整个刷新回同一个商品页**，
    //   然后弹出主题自带的「You have successfully subscribed!」小弹窗。
    //   URL 上会带 ?customer_posted=true —— 这就是「整页 POST /contact」的铁证
    //  （线上实测：给商品页 URL 追加 ?customer_posted=true，主题弹窗必现）。
    //
    // 根因（读 Shopify 注入的 captcha-bootstrap 内联脚本源码得出）：
    //   Shopify 的 captcha bootstrap 用选择器
    //     form[action*='/contact']:not([data-nocaptcha='true'])
    //       input[name='form_type'][value='customer']
    //   把本弹窗这个 customer 表单纳入名单，并在 document 上挂 submit 监听；
    //   命中条件
    //     c = 名单内 && form_key 缺失或为空
    //     n = 名单内 && 尚未绑定 hCaptcha
    //   时执行强制原生提交（其内部直接调用 form.submit()）。
    //   我们自己的 e.preventDefault() + fetch 通道会被彻底绕过 →
    //   整页刷新 → 弹窗状态、像素、购物车属性、折扣应用全部丢失。
    //
    // 三层封堵：
    //   ① data-nocaptcha="true" —— Shopify 官方逃生门。bootstrap 的选择器里带
    //      :not([data-nocaptcha='true'])，打上它表单就不再进名单
    //      （既不会被 preventDefault，也不可能被强制原生提交）。
    //      必须在本脚本**解析期**就设好：bootstrap 是在 DOMContentLoaded / focusin
    //      时才求值选择器，而本 snippet 渲染于 body 末尾、脚本同步执行 —— 时序稳赢。
    //   ② 提交按钮 type="submit" → "button"：点击不再产生 submit 事件，
    //      挂在 document 上的第三方处理器连事件都收不到。
    //   ③ 仍保留一个 submit 监听兜底（Enter 触发的隐式提交），一律 preventDefault。
    //
    // 注意：data-nocaptcha **不影响** hCaptcha token —— 我们仍然显式调用
    //   window.Shopify.captcha.protect(form, cb) 来 wire up 并拿到 h-captcha-response。
    // ============================================
    try { form.setAttribute('data-nocaptcha', 'true'); } catch (e) {}

    // ============================================
    // Facebook 像素上报（方案C：主题直连）
    // 像素 ID 配置在 snippets/facebook-pixel.liquid（主题设置 facebook_pixel_id）。
    // 那里会加载 fbevents.js 并暴露 window.atelierFbTrack 作为统一入口。
    //
    // 【重要修正记录】早期版本这里判断 typeof window.fbq === 'function'，
    // 但 Shopify Web Pixels 沙箱**不会**把 fbq 挂到页面，该判断恒为假，
    // 导致事件一条都发不出去（死代码）。现改为优先调用主题直连的
    // window.atelierFbTrack，回退到原生 fbq（兼容商户自行装像素的情况）。
    //
    // 上报失败绝不阻断主流程 —— 这是硬约束。
    // ============================================
    function fbTrack(eventName, params, eventId) {
      try {
        // 优先走主题直连通道（facebook-pixel.liquid 暴露）
        if (typeof window.atelierFbTrack === 'function') {
          return window.atelierFbTrack(eventName, params || {}, eventId);
        }
        // 回退：商户若自行引入了标准像素代码，仍可用
        if (typeof window.fbq === 'function') {
          // ATC-DEDUPE：带上 eventID 让 Meta 做服务端事件去重
          if (eventId) {
            window.fbq('track', eventName, params || {}, { eventID: eventId });
          } else {
            window.fbq('track', eventName, params || {});
          }
          return true;
        }
      } catch(e) {
        // 像素上报失败绝不能影响主流程
      }
      return false;
    }
    
    // 检查是否已经领取过优惠
    function hasDiscount() {
      try {
        return localStorage.getItem(STORAGE_KEY) === 'true';
      } catch(e) {
        return false;
      }
    }
    
    // 标记优惠已领取
    function setDiscountApplied(email) {
      try {
        localStorage.setItem(STORAGE_KEY, 'true');
        if (email) {
          localStorage.setItem(EMAIL_KEY, email);
        }
      } catch(e) {}
    }
    
    // 显示弹窗
    function showPopup() {
      // 如果已经领取过优惠（填写过邮箱），就不弹窗
      if (hasDiscount()) {
        return;
      }
      // 如果用户已经关闭过弹窗（当前会话），就不弹窗
      if (isPopupDismissed()) {
        return;
      }
      overlay.classList.add('active');
      // NON-MODAL（2026-09-27）：不再锁 body 滚动，页面随时可滚动 / 可点购物车与结账
      // document.body.style.overflow = 'hidden';
      // CAPTCHA-FIX：弹窗一出现就预热 hCaptcha，为后面的邮箱提交争取 token 就绪时间
      warmUpCaptcha();
    }
    
    // 检查用户是否关闭过弹窗
    function isPopupDismissed() {
      try {
        return sessionStorage.getItem(POPUP_DISMISSED_KEY) === 'true';
      } catch(e) {
        return false;
      }
    }
    
    // 标记用户已关闭弹窗
    function markPopupDismissed() {
      try {
        sessionStorage.setItem(POPUP_DISMISSED_KEY, 'true');
      } catch(e) {}
    }
    
    // 隐藏弹窗
    function hidePopup() {
      overlay.classList.remove('active');
      // 修复E：恢复页面原始滚动状态（必须还原为空字符串，避免残留 hidden 锁死页面）
      document.body.style.overflow = '';
      // 标记用户已关闭弹窗（当前会话不再显示）
      markPopupDismissed();
      // 确保焦点回到页面，允许正常操作
      if (document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
      }
    }
    
    // 显示成功状态
    // emailSaved === false 时**不得**声称「已保存邮箱」——只承诺折扣已应用（那是真的）。
    function showSuccess(emailSaved) {
      formContainer.style.display = 'none';
      successContainer.classList.add('show');
      try {
        var sub = document.getElementById('emailPopupSuccessSub');
        if (sub) {
          sub.textContent = (emailSaved === false)
            ? 'The discount is already applied \u2014 you will see the reduced total at checkout, no code needed. (We could not save your email for updates just now.)'
            : 'We saved your email, and the discount is already applied. You will see the reduced total at checkout \u2014 no code needed.';
        }
      } catch (e) {}
    }
    
    // 显示成功Toast提示（确保只在调用时显示，页面加载时不会显示）
    function showToast() {
      if (toast) {
        // 先确保完全隐藏
        toast.classList.remove('show');
        // 强制重排
        void toast.offsetWidth;
        // 再显示
        toast.classList.add('show');
        setTimeout(function() {
          toast.classList.remove('show');
        }, 3000);
      }
    }

    // ============================================
    // NO-FULL-POST 2026-09-19：提交结果如实反馈 + 整页提交落地页接管
    // ============================================
    // pending 标记：在客户点击提交的那一刻写入。
    // 若本次提交最终被平台强制整页 POST（页面会跳转），落地页读到该标记，
    // 就知道「这次提交源自本弹窗」，从而接管主题自带的订阅成功弹窗。
    var PENDING_SUBMIT_KEY = 'madeova_pending_submit';
    // 标记有效期：10 分钟。整页提交的往返只有几秒，给足余量即可；
    // 超过这个时间的标记视为残留（例如提交失败后用户又在别处订阅），不接管。
    var PENDING_SUBMIT_TTL_MS = 10 * 60 * 1000;

    // 提交未确认入库时的反馈：**绝不谎报成功**。
    // 旧版只要 fetch 发出去就显示「Discount applied」，实测 POST /contact 返回
    // 400（token 未就绪）时 UI 照样成功、还写死了 localStorage 的已领取标记 ——
    // 客户被骗、后台却永远查不到这个邮箱。
    function showSubmitFailure() {
      try {
        if (emailInput) emailInput.style.borderColor = '#ff6b6b';
        if (privacyTextEl) {
          privacyTextEl.textContent = 'We could not save your email just now. Please tap the button to try again.';
          privacyTextEl.style.color = '#ff6b6b';
        }
      } catch(e) {}
    }

    // 恢复表单的初始视觉（重试成功后调用）
    function resetSubmitVisual() {
      try {
        if (emailInput) emailInput.style.borderColor = '';
        if (privacyTextEl) {
          privacyTextEl.textContent = '🔒 We respect your privacy. Unsubscribe at any time.';
          privacyTextEl.style.color = '';
        }
      } catch(e) {}
    }

    // 接管「表单被平台强制整页 POST」后的落地页。
    // 触发条件（两个都要）：URL 带 customer_posted=true + 本地有 pending 标记。
    // 做三件事：① 压制主题那个丑弹窗；② 改弹我们自己的成功卡片；③ 清掉 URL 参数。
    function takeOverPostLanding() {
      try {
        if (String(window.location.search || '').indexOf('customer_posted=true') === -1) return;
        var raw = null;
        try { raw = localStorage.getItem(PENDING_SUBMIT_KEY); } catch(e) {}
        var ts = parseInt(raw, 10);
        if (!ts || !isFinite(ts) || ts <= 0) return;              // 无标记
        if ((Date.now() - ts) > PENDING_SUBMIT_TTL_MS) {          // 过期残留，清掉不接管
          try { localStorage.removeItem(PENDING_SUBMIT_KEY); } catch(e) {}
          return;
        }
        try { localStorage.removeItem(PENDING_SUBMIT_KEY); } catch(e) {}

        // ① 上类名：CSS 里的 !important 规则会压掉主题弹窗的 inline display:block
        document.documentElement.className += ' madeova-emailpopup-takeover';

        // ② 能落到这个页面说明 POST 确实成功了，补上「已领取」标记 + 弹我们自己的卡片
        var email = null;
        try { email = localStorage.getItem(EMAIL_KEY); } catch(e) {}
        if (email) {
          setDiscountApplied(email);
          overlay.classList.add('active');
          // NON-MODAL：不锁滚动
          // document.body.style.overflow = 'hidden';
          showSuccess();
        }

        // ③ 清参数，避免客户手动刷新时再次触发
        try { window.history.replaceState(null, '', window.location.pathname); } catch(e) {}
      } catch(e) {}
    }

    // 尽早执行：本脚本在 </body> 前同步执行，早于主题 $(document).ready 里的
    // popup.show()，所以这里加的类名一定来得及压制主题弹窗。
    takeOverPostLanding();

    
    // 修复C：自动应用折扣。
    // NO-FULL-POST 2026-09-19：实现从「隐藏 iframe」改为「fetch」。
    //   旧实现创建 iframe 访问 /discount/WOBBLE10，虽然 302 的 Set-Cookie 确实
    //   生效（线上实测 discount_code=WOBBLE10 三种方式都能设上），但站点带
    //   Content-Security-Policy: frame-ancestors 'none'，iframe 会持续抛
    //     "Framing 'https://madeova.com/' violates ... frame-ancestors 'none'"
    //   这条控制台报错纯粹是噪声，却极易在排查其他问题时被误判成「折扣没应用」。
    //   fetch + redirect:'manual' 同样能拿到 302 并让浏览器处理 Set-Cookie，
    //   不创建任何 DOM 节点、不触发 CSP、没有 onload 等待，更快也更干净。
    // done guard 保留：ensure 回调只被调用一次。
    function applyDiscountAutomatically(callback) {
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        if (callback) {
          callback();
        }
      }

      try {
        // redirect:'manual' → 拿到的是 opaqueredirect 响应，但 Set-Cookie 已被浏览器处理
        fetch('/discount/' + DISCOUNT_CODE, {
          method: 'GET',
          credentials: 'same-origin',
          redirect: 'manual'
        }).then(finish).catch(finish);
        // 超时保护：网络异常时也确保流程继续，绝不卡住客户
        setTimeout(finish, 3000);
      } catch(e) {
        finish();
      }
    }
    
    // 验证邮箱格式
    function isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
    
    // ============================================
    // 购物车归属：让商户在后台「客户」列表看到邮箱 + 加购商品
    // ============================================
    // 背景：Shopify 的客户档案与购物车是两套独立对象，匿名访客的购物车
    //      没有 customer_id，所以拿到邮箱也看不到他加购了什么。
    // 解法：拿到邮箱后，把「加购商品快照」写进两个地方：
    //   1) 购物车属性 attributes[Recovery Info]  → 进结账页即生成弃购记录，
    //      后台「弃购结账」列表里能看到「邮箱 + 商品 + 金额」
    //   2) 客户标签 contact[tags] → 后台「客户」列表可按标签筛选
    // 注意：标签只能存字符串，故做长度截断，避免超出 Shopify 标签长度限制。
    // ============================================
    
    var CART_SNAPSHOT_KEY = 'madeova_cart_snapshot';
    var MAX_TAG_LEN = 40; // Shopify 单个标签建议不超过 40 字符
    
    // 规范化商品标题为可用作标签的形式（去空格/特殊字符，截断）
    function toTagSlug(str) {
      if (!str) return '';
      var s = String(str)
        .replace(/[^\w\s\-]/g, '')   // 去掉标点
        .trim()
        .replace(/\s+/g, '-')        // 空格转连字符
        .toLowerCase();
      if (s.length > MAX_TAG_LEN) {
        s = s.slice(0, MAX_TAG_LEN);
      }
      return s;
    }
    
    // 读取当前购物车，生成加购商品快照
    // 返回 Promise，resolve 一个结构：
    //   { count, total, currency, items: [{ title, variant, qty, price }], tagString }
    function fetchCartSnapshot() {
      return new Promise(function(resolve) {
        try {
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function(r) { return r.ok ? r.json() : null; })
            .then(function(cart) {
              if (!cart || !cart.items) { resolve(null); return; }
              var items = cart.items.map(function(it) {
                return {
                  title: it.product_title || it.title,
                  variant: it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '',
                  qty: it.quantity,
                  price: it.price
                };
              });
              var snapshot = {
                count: cart.item_count,
                total: cart.total_price,
                currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
                items: items
              };
              // 生成标签串：cart-{件数}-{首个商品slug}
              // 例：cart-2-mens-genuine-leather-slip-on
              var first = items[0] ? toTagSlug(items[0].title) : '';
              snapshot.tagString = ('cart-' + cart.item_count + (first ? '-' + first : '')).slice(0, MAX_TAG_LEN);
              // 存入 localStorage，供后续会话/页面复用
              try { localStorage.setItem(CART_SNAPSHOT_KEY, JSON.stringify(snapshot)); } catch(e) {}
              resolve(snapshot);
            })
            .catch(function() { resolve(null); });
        } catch(e) { resolve(null); }
      });
    }
    
    // 把邮箱 + 购物车快照写入购物车属性（供后台弃购列表查看）
    // 同时写入 note，便于在订单/结账单上直接看到
    function attachRecoveryInfoToCart(email, snapshot) {
      return new Promise(function(resolve) {
        try {
          var attrValue = email;
          if (snapshot && snapshot.items && snapshot.items.length) {
            var parts = snapshot.items.map(function(it) {
              return it.qty + 'x ' + it.title + (it.variant ? ' (' + it.variant + ')' : '');
            });
            attrValue = email + ' | ' + parts.join(' ; ');
          } else {
            attrValue = email + ' | (cart empty at capture time)';
          }
          // Shopify 属性值不做长度硬限制，但过长的值可读性差，做软截断
          if (attrValue.length > 900) {
            attrValue = attrValue.slice(0, 900) + '...';
          }
          
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              attributes: {
                'Recovery Email': email,
                'Cart Snapshot': attrValue
              }
            })
          })
          .then(function() { resolve(true); })
          .catch(function() { resolve(false); });
        } catch(e) { resolve(false); }
      });
    }

    // 官方访客身份 API：把 email 回传给 Shopify（「留邮箱换折扣」官方推荐做法）。
    // 有了它，Shopify 的会话分析与弃购恢复流程都能识别该访客，不依赖客户进结账页。
    // API 不存在或失败时静默降级，绝不阻断主流程。
    function reportVisitorEmail(email) {
      try {
        if (email && window.Shopify && window.Shopify.analytics
            && typeof window.Shopify.analytics.visitor === 'function') {
          window.Shopify.analytics.visitor({ email: email });
        }
      } catch(e) {}
    }

    // ============================================
    // CAPTCHA-OWN（2026-09-19）—— 主题自持 hCaptcha
    // ============================================
    // 线上实测（真实有头浏览器 + 反自动化补丁，多轮对照）：
    //   · 平台的 protect(form, cb) 只做两件事：渲染 invisible widget、接管该表单的
    //     submit；**token 只在被接管的 submit 内部才产出**。
    //   · 本弹窗走 fetch，永远不碰表单的 submit → h-captcha-response 恒为空
    //     → POST /contact 恒 400，错误正文是 Missing CAPTCHA token。
    //     该失败与设备无关（手机真机 / 桌面有头 / 无头 表现完全一致）。
    // 结论：token 必须由主题自己取。改为自己加载 hcaptcha api、自己 render、
    //   自己 execute，再把 token 放进提交体。
    //   sitekey 从平台注入的脚本里现取（取不到用兜底常量），平台换 key 也能自愈。
    // ============================================
    // ============================================
    // CAPTCHA-OFF 总开关（2026-10-11 · 老板定「双保险」）
    // ============================================
    // 背景：本弹窗用 {% form 'customer' %}（action=/contact），属 Shopify hCaptcha 覆盖范围。
    //   为不让平台 captcha-bootstrap 强制整页原生提交，我们给表单打了 data-nocaptcha="true"
    //   脱离平台接管 ⇒ token 只能主题自持 ⇒ 一旦 hCaptcha 判访客为机器人，
    //   就会原地弹出 320x490 的可见挑战框（实测：自动化环境必弹）。
    // 双保险：① 后台「在线商店 → 偏好设置 → 垃圾邮件防护」关掉表单 hCaptcha；
    //         ② 此处总开关 = false ⇒ 即使后台仍开着，主题也**永不加载/永不 execute** hCaptcha。
    // 代价（已知并接受）：服务端要 token 时邮箱不入库 —— 但 10% 折扣照给，客户无感，
    //   且成功卡片会如实写「We could not save your email」，不谎报。
    // 恢复方法：把下面这行改成 true 即可（其余逻辑原封不动）。
    var CAPTCHA_ENABLED = false;

    var HCAPTCHA_SITEKEY_FALLBACK = 'f06e6c50-85a8-45c8-87d0-21a2b65856fe';
    var HCAPTCHA_SCRIPT_SRC = 'https://js.hcaptcha.com/1/api.js?render=explicit&recaptchacompat=off';
    var CAPTCHA_TOKEN_TTL_MS = 90 * 1000;
    var CAPTCHA_EXECUTE_TIMEOUT_MS = 8000;       // 单次 execute 上限（真机通常 1~3s 返回）
    // OFFICIAL-FALLBACK：预算刻意压短 —— 自持取不到 token 时要尽快让位给第 ③ 层官方通道，
    //   别让客户在「Applying Discount...」上干等十几秒。
    var CAPTCHA_TOTAL_BUDGET_MS = 12000;         // 多次尝试的**总**预算，超了就不再重试
    var CAPTCHA_API_TIMEOUT_MS = 15000;
    var captchaWarmedUp = false;
    var captchaWidgetId = null;
    var captchaToken = '';
    var captchaTokenAt = 0;
    var captchaRendering = false;

    // sitekey 自愈：优先从平台注入的 captcha 脚本里现取
    function resolveHcaptchaSitekey() {
      try {
        var boot = document.getElementById('captcha-bootstrap');
        var txt = boot ? String(boot.textContent || boot.innerText || '') : '';
        var m = txt.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/);
        if (m && m[0]) return m[0];
      } catch (e) {}
      return HCAPTCHA_SITEKEY_FALLBACK;
    }

    function loadHcaptchaApi() {
      if (window.hcaptcha && typeof window.hcaptcha.render === 'function') {
        return Promise.resolve(true);
      }
      return new Promise(function (resolve) {
        try {
          if (!document.querySelector('script[src*="js.hcaptcha.com"], #captcha-provider')) {
            var sc = document.createElement('script');
            sc.id = 'mdv-hcaptcha-api';
            sc.src = HCAPTCHA_SCRIPT_SRC;
            sc.async = true;
            sc.defer = true;
            document.head.appendChild(sc);
          }
        } catch (e) {}
        var t0 = Date.now();
        (function poll() {
          if (window.hcaptcha && typeof window.hcaptcha.render === 'function') return resolve(true);
          if (Date.now() - t0 > CAPTCHA_API_TIMEOUT_MS) return resolve(false);
          setTimeout(poll, 150);
        })();
      });
    }

    // 渲染属于本弹窗的 invisible widget。forceNew 时先清空容器重建。
    function ensureCaptchaWidget(forceNew) {
      if (captchaWidgetId !== null && captchaWidgetId !== undefined && !forceNew) {
        return Promise.resolve(captchaWidgetId);
      }
      if (captchaRendering) return Promise.resolve(null);
      captchaRendering = true;
      var holder = document.getElementById('emailPopupCaptchaHolder');
      if (holder) { try { holder.innerHTML = ''; } catch (e) {} }
      captchaWidgetId = null;
      return loadHcaptchaApi().then(function (ok) {
        if (!ok || !holder) { captchaRendering = false; return null; }
        try {
          captchaWidgetId = window.hcaptcha.render(holder, {
            sitekey: resolveHcaptchaSitekey(),
            size: 'invisible'
          });
        } catch (e) {
          console.warn('[EmailPopup] hCaptcha render 失败：' + (e && e.message));
        }
        captchaRendering = false;
        return captchaWidgetId;
      });
    }

    // 把 execute() 的三种结局（成功 / 拒绝 / 超时）统一收敛成 resolve(token 或 '')
    function settleCaptcha(resultPromise) {
      return new Promise(function (resolve) {
        var settled = false;
        var timer = setTimeout(function () {
          if (settled) return;
          settled = true;
          console.warn('[EmailPopup] hCaptcha execute 超时（' + CAPTCHA_EXECUTE_TIMEOUT_MS + 'ms）');
          resolve('');
        }, CAPTCHA_EXECUTE_TIMEOUT_MS);
        function finish(tok, why) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          if (why) console.warn('[EmailPopup] hCaptcha execute ' + why);
          resolve(tok || '');
        }
        try {
          Promise.resolve(resultPromise).then(function (res) {
            var tok = (res && res.response) || '';
            if (!tok && captchaWidgetId !== null && captchaWidgetId !== undefined) {
              try { tok = window.hcaptcha.getResponse(captchaWidgetId) || ''; } catch (e) {}
            }
            finish(tok, null);
          }).catch(function (err) {
            finish('', '失败：' + ((err && (err.message || err.error)) || err));
          });
        } catch (e) {
          finish('', '异常：' + (e && e.message));
        }
      });
    }

    // 取 token：90 秒内命中缓存直接用；否则现取，失败则重建 widget 再试一次。
    // ⚠️ 必须在用户手势内调用 —— hCaptcha 会评估 execute 是否由真实交互触发。
    function obtainCaptchaToken() {
      if (!CAPTCHA_ENABLED) return Promise.resolve('');   // CAPTCHA-OFF 总开关：永不取 token
      if (captchaToken && (Date.now() - captchaTokenAt) < CAPTCHA_TOKEN_TTL_MS) {
        return Promise.resolve(captchaToken);
      }
      // 平台没注入 captcha 引导脚本 → 本店没启用表单验证码，直接放弃（返回空串）
      if (!platformUsesCaptcha()) return Promise.resolve('');
      var startedAt = Date.now();
      function retryIfBudgetLeft() {
        // ⚠️ 不要无限重试：每次尝试都要等 CAPTCHA_EXECUTE_TIMEOUT_MS，
        //    叠加起来会把用户按在「Applying Discount...」上几十秒。
        if (Date.now() - startedAt > CAPTCHA_TOTAL_BUDGET_MS - CAPTCHA_EXECUTE_TIMEOUT_MS) {
          return Promise.resolve('');
        }
        return ensureCaptchaWidget(true).then(function () { return retryCaptcha(); });
      }
      var wid = captchaWidgetId;
      if (wid !== null && wid !== undefined && window.hcaptcha) {
        var p = null;
        try { p = window.hcaptcha.execute(wid, { async: true }); } catch (e) { p = null; }
        if (p) {
          return settleCaptcha(p).then(function (tok) {
            if (tok) { captchaToken = tok; captchaTokenAt = Date.now(); return tok; }
            return retryIfBudgetLeft();
          });
        }
      }
      return ensureCaptchaWidget(false).then(function () { return retryCaptcha(); });
    }

    function retryCaptcha() {
      var wid = captchaWidgetId;
      if (wid === null || wid === undefined || !window.hcaptcha) return Promise.resolve('');
      var p = null;
      try { p = window.hcaptcha.execute(wid, { async: true }); } catch (e) { return Promise.resolve(''); }
      return settleCaptcha(p).then(function (tok) {
        if (tok) { captchaToken = tok; captchaTokenAt = Date.now(); }
        return tok || '';
      });
    }

    // 本店是否启用了**平台级**表单验证码：以平台注入的引导脚本是否存在为准。
    // 后台「在线商店 → 偏好设置 → 垃圾邮件防护」把「在联系和评论表单上启用」
    // 关掉后，该脚本可能仍存在（账号表单还在用），但那不影响我们 —— 我们
    // 只在服务端**真的要 token** 时才取（见 CAPTCHA-ON-DEMAND 提交编排）。
    function platformUsesCaptcha() {
      try { return !!document.getElementById('captcha-bootstrap'); } catch (e) { return false; }
    }

    // 弹窗一出现就预热：只预热 render，**不预热 execute**。
    // execute 要等「服务端确认需要 token」时才发起 —— 无脑预弹验证码是转化杀手。
    function warmUpCaptcha() {
      if (!CAPTCHA_ENABLED) return;         // CAPTCHA-OFF 总开关：关掉后完全不碰 hCaptcha
      if (captchaWarmedUp) return;
      captchaWarmedUp = true;
      if (!platformUsesCaptcha()) return;   // 本店没启用表单验证码 → 完全不碰 hCaptcha
      ensureCaptchaWidget(false);           // 只渲染备用，不 execute
    }

    // 读当前写入表单的 token（仅用于日志与失败归因，业务不依赖它）
    function readCaptchaToken() {
      try {
        var el = form && form.querySelector('textarea[name="h-captcha-response"], input[name="h-captcha-response"]');
        return el ? String(el.value || '') : '';
      } catch (e) { return ''; }
    }

    // ============================================
    // OFFICIAL-FALLBACK 2026-09-19：官方支持的整页提交通道（第 ③ 层兜底）
    // ============================================
    // 何时走到这里：服务端明确回 Missing CAPTCHA token，且我们**自持 execute 也取不到 token**
    //   （hCaptcha 风控把访客判为机器人时就是这种结果）。
    //
    // 为什么这层一定有效：token 的产出权其实在**平台**手里 —— 平台在用户与表单交互时
    //   （focusin/change）会自动 wire up；我们也可以用官方支持的
    //   Shopify.captcha.protect(form, cb) 主动要求 wire up。
    //   wire up 完成后，form.submit 会被平台**接管**：调用它 = 「先 execute 写 token，
    //   再原生整页提交」。这是 Shopify 官方文档给出的示例写法，也是唯一被官方支持的
    //   程序化提交方式（官方明确劝退直接调 window.hCaptcha）。
    //
    // ⚠️ 两个必须守住的细节：
    //   ① 必须在 protect 的**回调里**才调 form.submit() —— 回调代表 captcha 已就绪、
    //      form.submit 已被接管。提前调用 = 原生裸提交 = 客户看到 Shopify 的
    //      "Missing CAPTCHA token" 错误页（比提交失败更糟）。
    //   ② 整页提交会带走表单字段，但**不会带走我们临时拼的 FormData 标签** ——
    //      所以要把购物车标签先写回表单的 contact[tags]，否则后台会丢掉
    //      cart-{n}-{slug} / has-cart / cartval-{n} 这些标记。
    // 参数 extraTags：与 submitEmailToShopify 同源，用于回填 contact[tags]。
    // 返回 Promise<boolean>：true = 已发起整页提交；false = 通道不可用（调用方按失败处理）。
    function fallbackToOfficialSubmit(extraTags) {
      if (!form || !form.action) return Promise.resolve(false);

      // ② 回填购物车标签（去重，与 fetch 路径保持同一套标签口径）
      try {
        if (extraTags && extraTags.length) {
          var el = form.elements['contact[tags]'];
          if (el) {
            var seen = {};
            var merged = [];
            (String(el.value || '') + ',' + extraTags.filter(Boolean).join(',')).split(',').forEach(function (t) {
              t = String(t).trim();
              if (t && !seen[t]) { seen[t] = 1; merged.push(t); }
            });
            if (merged.length) el.value = merged.join(',');
          }
        }
      } catch (e) {}

      var api = window.Shopify && window.Shopify.captcha;
      if (!api || typeof api.protect !== 'function') {
        console.warn('[EmailPopup] 官方 captcha 通道不可用（页面未注入 protect API）');
        return Promise.resolve(false);
      }

      return new Promise(function (resolve) {
        var settled = false;
        function fire() {
          if (settled) return;
          settled = true;
          console.warn('[EmailPopup] 官方通道就绪：整页提交（平台已接管 form.submit）');
          try { form.submit(); resolve(true); }
          catch (e) { console.warn('[EmailPopup] 官方通道提交异常：' + (e && e.message)); resolve(false); }
        }
        try {
          // 官方文档示例写法：在回调里提交表单
          api.protect(form, fire);
        } catch (e) {
          console.warn('[EmailPopup] protect 调用失败：' + (e && e.message));
          resolve(false);
          return;
        }
        // 兜底：平台回调迟迟不来就静默放弃。
        // ⚠️ 这里**绝不**自己去调 form.submit() 顶替 —— 那会是原生裸提交，把客户送到错误页。
        setTimeout(function () {
          if (!settled) {
            settled = true;
            console.warn('[EmailPopup] 官方通道未在 9s 内就绪，放弃（保持弹窗以便重试）');
            resolve(false);
          }
        }, 9000);
      });
    }

    // 留过邮箱之后，后续每次加购都静默刷新购物车快照 ——
    // 保证弃购记录 / 订单上看到的商品清单是「最新的」，而不是留邮箱那一刻的旧数据。
    // 节流 8 秒，避免连续快速加购时打爆 /cart/update.js。
    var lastRecoveryRefreshAt = 0;
    function refreshCartRecovery() {
      try {
        var email = null;
        try { email = localStorage.getItem(EMAIL_KEY); } catch(e) {}
        if (!email) return;                          // 还没留过邮箱 —— 没有可绑定的身份
        var now = Date.now();
        if (now - lastRecoveryRefreshAt < 8000) return;
        lastRecoveryRefreshAt = now;
        fetchCartSnapshot().then(function(snapshot) {
          if (snapshot) attachRecoveryInfoToCart(email, snapshot);
        });
      } catch(e) {}
    }
    
    // 真实提交邮箱到 Shopify 客户列表
    // 用 fetch 提交 customer form（Liquid 的 form 'customer' 标签会渲染 form_type 等必需字段）。
    // ⚠️ LIQUID-HAZARD 2026-09-18：本行原本把那个标签连同 Liquid 定界符一起写了出来。
    //    但 script 块**不是** comment 块 —— 块内的 Liquid 标签照样会被解析；
    //    而该标签没有配对的 endform，属于未闭合块标签 → Liquid 编译期抛 SyntaxError
    //    （lax 模式也不会忽略）→ 整个 snippet 渲染输出为空 → 线上弹窗连同 DOM 一起消失。
    //    实测后果：加购后不再弹出收集邮箱的窗口。
    //    铁律：**JS 注释里绝对不要出现 Liquid 定界符**（左大括号 + 百分号 / 百分号 + 右大括号），
    //    需要提及标签时只写纯文字，例如「form 标签」「comment 块」。
    // CAPTCHA-FIX 2026-09-18 的两处关键改动：
    //   ① **FormData 必须在 hCaptcha 产出 token 之后再构造**，否则
    //      h-captcha-response 为空 → Shopify 返回 400 Missing CAPTCHA token。
    //      旧代码在用户点提交的瞬间就 new FormData(form)，早于 wire up 完成。
    //   ② **按真实 HTTP 状态判定成功**。旧代码 .then(function(){ resolve(true) })
    //      把「请求发出去了」当成「提交成功」，400/403 被静默吞掉 ——
    //      邮箱根本没入库，界面却显示"Email Saved"，后台自然也查不到。
    // 任何失败仍优雅降级：绝不阻断折扣应用。
    // 参数 extraTags：额外追加到 contact[tags] 的标签数组（用于标记加购商品）
    function submitEmailToShopify(email, extraTags, captchaTokenValue) {
      // NO-FULL-POST 2026-09-19：返回值语义化。
      //   旧版 resolve(true/false)，调用方只判断真值 —— 而线上实测 POST /contact
      //   返回 400「Missing CAPTCHA token」时界面依旧显示成功、还写死了
      //   madeova_discount_applied=true（此后永久不再弹窗）。客户被骗、
      //   后台却查不到这个邮箱。现在返回 {ok, reason}，调用方按 ok 分支处理。
      return new Promise(function(resolve) {
        if (!form || !form.action) {
          resolve({ ok: false, reason: 'no-form' });
          return;
        }
        // 关键时序：先等 captcha 就绪，再拿 form 里的字段
        (function() {
          try {
            var fd = new FormData(form);
            // 追加购物车相关标签，让后台「客户」列表能按标签筛选出「加了哪个商品」。
            // CAPTCHA-FIX：按逗号拆分后去重 —— 旧写法会把表单里已有的
            // newsletter,10-offer 再拼一遍，产出
            // newsletter,10-offer,newsletter,10-offer,... 这种脏标签。
            if (extraTags && extraTags.length) {
              var existing = fd.get('contact[tags]') || '';
              var seen = {};
              var merged = [];
              (existing + ',' + extraTags.filter(Boolean).join(',')).split(',').forEach(function(t) {
                t = String(t).trim();
                if (t && !seen[t]) { seen[t] = 1; merged.push(t); }
              });
              if (merged.length) fd.set('contact[tags]', merged.join(','));
            }
            // CAPTCHA-OWN：token 由调用方在用户手势内取好并传进来
            var tok = captchaTokenValue || readCaptchaToken();
            if (tok) fd.set('h-captcha-response', tok);

            fetch(form.action, {
              method: 'POST',
              body: fd,
              headers: { 'Accept': 'application/json' },
              // manual：customer form 提交成功后是 302 → ?customer_posted=true
              redirect: 'manual'
            }).then(function(resp) {
              // opaqueredirect 即 302（被 manual 屏蔽成不透明响应）→ 成功
              var okStatus = resp.type === 'opaqueredirect' ||
                             (resp.status >= 200 && resp.status < 400);
              if (okStatus) { resolve({ ok: true, tokenLen: tok.length }); return; }
              // 4xx/5xx：尽量读出 Shopify 给的错误原因，便于后台排查
              resp.text().then(function(t) {
                var reason = 'HTTP ' + resp.status;
                try { var j = JSON.parse(t); if (j && j.errors) reason = j.errors; } catch(e) {}
                // CAPTCHA-ON-DEMAND：识别服务端是否在要验证码。
                // 只有这种情况才值得去取 token 重试；其余 4xx（参数错、限流等）重试无意义。
                var needCaptcha = /missing captcha token/i.test(String(reason) + ' ' + String(t));
                console.warn('[EmailPopup] 邮箱未入库：' + reason +
                             '（hCaptcha token 长度 ' + tok.length + '，needCaptcha=' + needCaptcha + '）');
                resolve({ ok: false, reason: reason, tokenLen: tok.length, needCaptcha: needCaptcha });
              }).catch(function() {
                console.warn('[EmailPopup] 邮箱未入库：HTTP ' + resp.status);
                resolve({ ok: false, reason: 'HTTP ' + resp.status, tokenLen: tok.length, needCaptcha: false });
              });
            }).catch(function(e) {
              // 网络失败：优雅降级，不阻断折扣
              console.warn('[EmailPopup] 邮箱提交网络失败：' + (e && e.message));
              resolve({ ok: false, reason: 'network:' + (e && e.message) });
            });
          } catch(e) {
            resolve({ ok: false, reason: 'exception:' + (e && e.message) });
          }
        })();
      });
    }
    
    // 表单提交处理
    // NO-FULL-POST 2026-09-19：由「按钮 click 驱动」取代「submit 事件驱动」。
    //   原因见文件上方 NO-FULL-POST 防线注释 —— 只要 submit 事件冒泡到 document，
    //   Shopify 的 captcha bootstrap 就有机会调用 form.submit() 造成整页刷新。
    //   现在三条入口（按钮 click / Enter 键 / submit 兜底）全部收敛到 handleEmailSubmit()，
    //   且按钮已改 type="button"，正常路径下根本不会产生 submit 事件。
    var submitting = false;
    function handleEmailSubmit() {
      if (submitting) return;                        // 重入锁：防止连点造成重复提交
      var email = emailInput ? emailInput.value.trim() : '';

      if (!email || !isValidEmail(email)) {
        if (emailInput) {
          emailInput.style.borderColor = '#ff6b6b';
          emailInput.focus();
        }
        return;
      }

      // 显示加载状态
      submitting = true;
      // 写下 pending 标记：万一本次提交仍被平台强制整页 POST，落地页靠它认领。
      // 存时间戳而非 'true' —— 便于在落地页判断标记是否已过期（防误接管）。
      try { localStorage.setItem(PENDING_SUBMIT_KEY, String(Date.now())); } catch(e) {}
      submitBtn.disabled = true;
      submitBtn.textContent = 'Applying Discount...';
        
        // ============================================
      // CAPTCHA-ON-DEMAND 提交编排（2026-09-19）
      // ============================================
      // 原则：
      //   ① 折扣立刻应用 —— 它不走 /contact、不需要 captcha，是给客户的承诺；
      //   ② 邮箱**先不带 token 提交一次** —— 大多数商店并没有对 /contact 强制验证码，
      //      这样既不弹挑战、也不加载 hCaptcha；
      //   ③ 只有服务端明确回 Missing CAPTCHA token 时，才现取 token **重试一次**。
      //      （无脑预弹验证码 = 把「领 10% 折扣」变成解题游戏，是转化杀手。）
      //   ④ 拿不到 token 也绝不谎报邮箱已保存。
      var emailOutcome = null;   // null=未定 / 'saved' / 'failed'

      // 折扣：最短路径，立即执行并立即反馈
      applyDiscountAutomatically(function () {
        showSuccess(emailOutcome === 'saved');
        submitting = false;
        submitBtn.disabled = false;
        submitBtn.textContent = 'Apply 10% Discount 🚀';
      });

      // 邮箱：并行推进，完成后升级成功卡片文案
      var snapshotPromise = fetchCartSnapshot().catch(function () { return null; });

      snapshotPromise.then(function (snapshot) {
        // 组装标签：保留原有 newsletter / 10-offer，追加购物车标记
        var tags = ['newsletter', '10-offer'];
        if (snapshot && snapshot.tagString) {
          tags.push(snapshot.tagString);
        }
        if (snapshot && snapshot.count > 0) {
          tags.push('has-cart');
        }
        if (snapshot && snapshot.count > 0 && snapshot.total > 0) {
          tags.push('cartval-' + Math.round(snapshot.total / 100));
        }

        // 按需取 token：第一次不带 token 试；服务端要就现取一次再重试
        function attemptSubmit(token, retried) {
          return submitEmailToShopify(email, tags, token).then(function (result) {
            if (!result.ok && result.needCaptcha && !retried && CAPTCHA_ENABLED) {
              console.warn('[EmailPopup] 服务端要求 hCaptcha token，先试主题自持 token');
              return obtainCaptchaToken().then(function (tok2) {
                if (tok2) return attemptSubmit(tok2, true);
                // 自持拿不到 token → 第 ③ 层：改用**官方支持的整页提交通道**。
                //   平台自己 execute + 写 token + 提交，即使访客被判机器人也由平台兜底。
                console.warn('[EmailPopup] 自持 token 未取得，改用官方 captcha 通道整页提交');
                return fallbackToOfficialSubmit(tags).then(function (fired) {
                  if (fired) {
                    // 交给上面的消费者处理：保留 pending 标记，等落地页接管
                    return { ok: false, reason: 'official-submit-fired', needCaptcha: true, tokenLen: 0 };
                  }
                  return result;                   // 通道不可用 → 如实失败，绝不谎报
                });
              });
            }
            return result;
          });
        }

        attemptSubmit('', false).then(function (result) {
          // OFFICIAL-FALLBACK：官方通道已发起整页提交 —— 此时**绝不能清 pending 标记**，
          //   落地页正是靠它认领并显示我们自己的成功卡片（takeOverPostLanding）。
          //   也**不能**再走"失败"分支：页面马上会被平台提交掉，报失败只会误导客户。
          if (result && result.reason === 'official-submit-fired') {
            console.warn('[EmailPopup] 官方通道已触发整页提交，保留 pending 标记等待落地页接管');
            submitBtn.disabled = true;
            submitBtn.textContent = 'Verifying…';
            // ANTI-HANG 2026-10-11：表单带着 data-nocaptcha="true"，平台**不会**真的整页提交。
            //   实测出现过：通道返回 fired=true 却没有跳转 → 按钮永久停在 Verifying…，客户僵住。
            //   兜底：4s 内若页面未卸载，判定通道未生效，恢复按钮 + 如实走失败分支。
            //   （真发生跳转时页面卸载，本定时器不会执行，无副作用。）
            setTimeout(function () {
              try { localStorage.removeItem(PENDING_SUBMIT_KEY); } catch (e) {}
              submitBtn.disabled = false;
              submitBtn.textContent = 'Apply 10% Discount 🚀';
              submitting = false;
              emailOutcome = 'failed';
              console.warn('[EmailPopup] 官方通道 4s 内未发生整页跳转，已恢复按钮（防卡死）');
            }, 4000);
            return;
          }
          // 只有**确认入库**才落「已领取」标记（旧版无条件写死，会让客户永久不再重试）
          var emailSaved = !!(result && result.ok);
          emailOutcome = emailSaved ? 'saved' : 'failed';
          // 能进这个回调就证明页面没有整页跳转，pending 标记可安全清除
          try { localStorage.removeItem(PENDING_SUBMIT_KEY); } catch (e) {}

          if (emailSaved) {
            setDiscountApplied(email);
            resetSubmitVisual();
            showToast();
          } else {
            console.warn('[EmailPopup] 留资未确认入库（' + ((result && result.reason) || 'unknown') +
                         '，token 长度 ' + ((result && result.tokenLen) || 0) + '），保留弹窗以便重试');
          }

          // 成功卡片已展示 → 按真实结果升级副文案；未展示则由上面的折扣回调负责渲染
          if (successContainer.classList.contains('show')) {
            showSuccess(emailSaved);
          }

          // Lead 像素只在**确认入库**后上报 —— 广告后台口径必须与业务后台一致
          if (emailSaved && email) {
            var leadParams = {
              content_name: 'Welcome10 Email Capture',
              currency: (snapshot && snapshot.currency)
                ? snapshot.currency
                : ((window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD')
            };
            if (snapshot && snapshot.count > 0) {
              leadParams.value = snapshot.total / 100;
              leadParams.num_items = snapshot.count;
            }
            fbTrack('Lead', leadParams);
          }

          // 购物车属性兜底：这条路不经过 /contact、不受 captcha 影响。
          // 即使留资那步失败，后台「弃购结账」里仍能看到这个邮箱与购物车内容。
          attachRecoveryInfoToCart(email, snapshot);

          // 官方访客身份 API：把邮箱回传 Shopify（失败静默降级）
          reportVisitorEmail(email);
        });
      });
    }

    // 三条提交入口全部收敛到 handleEmailSubmit()
    // ① 主路径：按钮点击（按钮已改 type="button"，不产生 submit 事件）
    if (submitBtn) {
      submitBtn.addEventListener('click', function(e) {
        e.preventDefault();
        handleEmailSubmit();
      });
    }
    // ② Enter 键：输入框内回车（显式拦截，避免浏览器隐式提交整页刷新）
    if (emailInput) {
      emailInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          e.preventDefault();
          handleEmailSubmit();
        }
      });
    }
    // ③ 兜底：任何第三方脚本触发 requestSubmit() / submit 事件时一律拦下
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        handleEmailSubmit();
      });
    }
    
    // 继续购物按钮
    if (continueShoppingBtn) {
      continueShoppingBtn.addEventListener('click', function() {
        hidePopup();
      });
    }

    // PLAN-3（2026-09-27）：弹窗任意一步，结账按钮一点直达 /checkout，绝不被弹窗拦截
    function goCheckoutNow() {
      try { window.location.href = '/checkout'; }
      catch (e) { window.location = '/checkout'; }
    }
    if (directCheckoutBtn) {
      directCheckoutBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goCheckoutNow();
      });
    }
    if (checkoutAfterDiscountBtn) {
      checkoutAfterDiscountBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goCheckoutNow();
      });
    }
    
    // 复制优惠码
    if (couponCopyBtn) {
      couponCopyBtn.addEventListener('click', function() {
        var textArea = document.createElement('textarea');
        textArea.value = DISCOUNT_CODE;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          couponCopyBtn.textContent = 'Code copied';
          couponCopyBtn.classList.add('copied');
          setTimeout(function() {
            couponCopyBtn.textContent = 'Copy code';
            couponCopyBtn.classList.remove('copied');
          }, 2000);
        } catch(e) {}
        document.body.removeChild(textArea);
      });
    }
    
    // 关闭按钮
    if (closeBtn) {
      closeBtn.addEventListener('click', hidePopup);
    }
    
    // 点击遮罩层关闭
    if (overlay) {
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) {
          hidePopup();
        }
      });
    }
    
    // ESC键关闭
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('active')) {
        hidePopup();
      }
    });
    
    // 修复D：加购监听器节流 + 去重守卫
    // 同一个加购行为在 500ms 内只允许"尝试弹窗"一次；
    // 且 lastAddToCartPayload 记录最近一次加购数据，供像素 AddToCart 事件使用。
    var lastPopupAttempt = 0;
    var POPUP_THROTTLE_MS = 500;
    var lastAddToCartPayload = null;
    // ATC-DEDUPE：已处理过的加购事件 ID。即使监听器被重复注册（历史上
    // safeInit 无幂等守卫导致注册 2 个），同一笔加购也只会被处理一次。
    var handledAtcEventIds = {};
    
    // ============================================
    // 【2026-09-17 弹窗冲突修复】加购成功弹窗与邮箱弹窗时序协调
    // 冲突现象：加购后 cospora 弹「Added to Cart」成功弹窗（z-index 10000，
    //   fadeIn(500) → 5 秒 → fadeOut(500)，见 assets/cospora.js showModal），
    //   本弹窗在 fetch 响应后立即弹出（z-index 999999），把成功弹窗整个盖死，
    //   用户看到两层弹窗叠罗汉，成功反馈被吞。
    // 协调规则：加购 → 成功弹窗先完整展示（约 5.5 秒生命周期）
    //   → 邮箱弹窗再弹（自最后一次加购起 6 秒）。
    // 多次快速加购：以最后一次加购为基准刷新计时，确保邮箱弹窗
    //   永远在最后一次成功弹窗淡出之后才出现。
    // showPopup 内部自带 hasDiscount / isPopupDismissed 双重拦截，
    // 等待期内用户若已领折扣或关闭过弹窗，到时也不会弹。
    // ============================================
    var SUCCESS_MODAL_LIFETIME_MS = 6000;
    var popupTimerAfterSuccessModal = null;
    
    function schedulePopupAfterSuccessModal() {
      if (popupTimerAfterSuccessModal) {
        clearTimeout(popupTimerAfterSuccessModal);
      }
      popupTimerAfterSuccessModal = setTimeout(function () {
        popupTimerAfterSuccessModal = null;
        showPopup();
      }, SUCCESS_MODAL_LIFETIME_MS);
    }
    
    function tryShowPopup() {
      var now = Date.now();
      if (now - lastPopupAttempt < POPUP_THROTTLE_MS) {
        return; // 500ms 内的重复触发直接忽略
      }
      lastPopupAttempt = now;
      if (!hasDiscount()) {
        schedulePopupAfterSuccessModal();
      }
    }
    
    // 加购成功时上报 Facebook 像素 AddToCart
    // 补齐 content_ids / content_name / value / currency / num_items，
    // 便于 Meta 做动态商品广告（DPA）与价值优化。
    // ATC-DEDUPE-CROSS（2026-09-19）：本弹窗有 2 个加购触发源（fetch 钩子 +
    // 主题自定义事件），两者对同一笔加购都会调到这里。历史实测：一次真实加购上报
    // 2 次 FB AddToCart（两次调用一次带 eventID 一次不带，Meta 无法合并）。
    // 这里做 1.5 秒窗口去重，保证「一次加购 = 一个 AddToCart」。
    var lastAtcTrackedAt = 0;
    var ATC_TRACK_DEDUPE_MS = 1500;
    function trackAddToCart(eventId) {
      var nowAtc = Date.now();
      if (nowAtc - lastAtcTrackedAt < ATC_TRACK_DEDUPE_MS) {
        console.log('Email popup: AddToCart 重复触发已忽略（跨触发源去重）');
        return;
      }
      lastAtcTrackedAt = nowAtc;
      var payload = lastAddToCartPayload;
      var currency = (payload && payload.currency)
        ? payload.currency
        : ((window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD');
      var params = {
        content_type: 'product',
        currency: currency
      };
      if (payload) {
        if (payload.variantId) params.content_ids = [String(payload.variantId)];
        if (payload.productId) params.content_category = String(payload.productId);
        if (typeof payload.value === 'number') params.value = payload.value;
        if (payload.title) params.content_name = payload.title;
        if (typeof payload.quantity === 'number') params.num_items = payload.quantity;
      }
      // 加购是核心转化事件，若拿不到 value 也照发（宁可少字段，不可丢事件）
      //
      // ============================================================
      // ATC-DUPLICATE-FIX 2026-09-27（真机实测确认）
      // ------------------------------------------------------------
      // 现象：FB 广告后台加购数呈「2 个 2 个」整数倍。
      // 实测（3 轮真机复现，每轮结果一致）：一次真实用户加购 → Meta 收到
      //   · 主题直连通道 fbq('track','AddToCart')   ×1   ← 本函数
      //   · 平台 Web Pixel 沙箱 trackShopify('AddToCart') ×1
      //   （Shopify 后台「Facebook & Instagram」渠道 app 订阅了
      //     product_added_to_cart 标准事件，会独立上报一次）
      //   ⇒ 合计 2 次，且两条管道用的是**同一个像素 ID 2826700404370129**，
      //      eventID 格式还不同（主题 atc_xxx / 平台 sh-xxx），
      //      Meta 无法去重 ⇒ 后台把一次加购记成 2。
      //
      // 反证实验：掐掉本行后平台通道仍稳定上报 1 次（事件不丢），
      //            加购业务不受影响（购物车件数正常 +1）。
      //
      // 处置：主题侧不再上报 AddToCart —— 该事件已由平台官方渠道 app 覆盖，
      //       主题只需保留 Lead（邮箱订阅）这类沙箱发不出的事件。
      // 可逆：把下面 MADEOVA_THEME_TRACK_ADD_TO_CART 改成 true 即恢复旧行为
      //       （恢复后 Meta 会重新收到 2 次，仅在平台渠道 app 被卸载时才应打开）。
      // ============================================================
      var MADEOVA_THEME_TRACK_ADD_TO_CART = false;
      if (MADEOVA_THEME_TRACK_ADD_TO_CART) {
        fbTrack('AddToCart', params, eventId);
      }
    }
    
    // 监听加入购物车事件
    function initAddToCartListener() {
      // ATC-DEDUPE 2026-09-18：幂等守卫。
      // 本函数此前没有守卫，而 safeInit 会被调用两次，导致监听器注册 2 个，
      // 一次加购上报 2 次 FB AddToCart（实测最终放大成 8 次）。
      // 另外 window.fetch 也会被重复包装两层。这里一次性拦住。
      if (window.__atelierAtcListenerInstalled) return;
      window.__atelierAtcListenerInstalled = true;

      // 修复D：精简为 2 个可靠触发源（1+2），移除 MutationObserver 与点击兜底
      // 触发源1：Shopify AJAX 加购 fetch hook（带去重守卫 + 节流）
      var originalFetch = window.fetch;
      if (originalFetch) {
        window.fetch = function() {
          var url = arguments[0];
          var isAddToCart = url && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/add.js') !== -1);
          if (isAddToCart) {
            // 记录加购载荷，供像素上报使用
            try {
              var bodyStr = arguments[1] && arguments[1].body;
              if (typeof bodyStr === 'string') {
                var parsed = JSON.parse(bodyStr);
                var item = parsed && parsed.items && parsed.items[0];
                if (item) {
                  lastAddToCartPayload = {
                    variantId: item.id,
                    quantity: item.quantity || 1
                  };
                }
              }
            } catch(e) {}
            return originalFetch.apply(this, arguments).then(function(response) {
              // ATC-DEDUPE：只有加购真的成功（2xx）才上报。
              // 旧代码只看「fetch 返回了」，因此 422 库存不足 / 400 参数错误
              // 也会照发 AddToCart —— 等于给广告算法喂假信号。
              if (response && response.status >= 200 && response.status < 300) {
                tryShowPopup();
                trackAddToCart();
                refreshCartRecovery();   // 留过邮箱的客户：静默同步最新购物车快照
              }
              return response;
            });
          }
          return originalFetch.apply(this, arguments);
        };
      }
      
      // 触发源2：主题自定义事件 atelier:added-to-cart（最可靠，主题主动派发）
      // 该事件可能带有 detail（variantId/title/value/quantity），用于像素参数
      document.addEventListener('atelier:added-to-cart', function(evt) {
        // ATC-DEDUPE：按 eventId 去重 —— 同一笔加购无论被投递几次，只处理一次。
        // 这是幂等守卫之外的最后一道防线（防止将来又出现重复注册）。
        var detail = (evt && evt.detail) || {};
        if (detail.eventId) {
          if (handledAtcEventIds[detail.eventId]) return;
          handledAtcEventIds[detail.eventId] = 1;
        }
        try {
          if (evt && evt.detail) {
            lastAddToCartPayload = {
              variantId: detail.variantId || detail.id || null,
              quantity: detail.quantity || 1,
              title: detail.title || null,
              value: (typeof detail.value === 'number') ? detail.value : undefined
            };
          }
        } catch(e) {}
        tryShowPopup();
        trackAddToCart(detail.eventId);
        refreshCartRecovery();   // 留过邮箱的客户：静默同步最新购物车快照
      });
      
      // ------------------------------------------------------------------
      // 触发源3（madeova 移植新增 2026-10-10）：cospora 的加购走 jQuery $.ajax
      //   （assets/cospora.js:2801 doAjaxAddToCartNormal -> url: "/cart/add.js"），
      //   既不是 window.fetch、也不派发任何自定义事件 —— 也就是说 v54 的
      //   「触发源1 fetch hook」与「触发源2 atelier:added-to-cart」在 madeova 上
      //   **两个都收不到**。这里用 jQuery 全局 ajaxSuccess 把主题既有的加购成功
      //   回调桥接成 atelier:added-to-cart，从而原样复用上面的时序协调
      //   （加购成功弹窗先走完 ~5.5s，再等 6s 才弹邮箱弹窗）。
      //   这样不必改动 cospora.js，也**不会**像 v54 产品模板那样重复发一次
      //   /cart/add.js 请求（那会导致数量 +2）。
      // ------------------------------------------------------------------
      // jQuery 由 snippets/head_scripts.liquid 在 head 同步加载，理论上本脚本执行时已在位；
      // 但为防将来有人把它改成 async/defer，这里做最多 5 秒的重试，装不上也只是没有弹窗，
      // 绝不影响加购本身。
      (function installAtcBridge(attempt) {
        if (window.jQuery) {
          window.jQuery(document)
            .off('ajaxSuccess.madeovaAtcBridge')
            .on('ajaxSuccess.madeovaAtcBridge', function (evt, xhr, options, data) {
              try {
                if (String(options.type || options.method || 'GET').toUpperCase() !== 'POST') return;
                var u;
                try { u = new URL(options.url, window.location.href); } catch (e) { return; }
                if (u.origin !== window.location.origin) return;
                if (!/\/cart\/add(?:\.js)?\/?$/.test(u.pathname)) return;
                if (xhr.status < 200 || xhr.status >= 300 || !data || data.status) return;
                if (!(data.id || (Array.isArray(data.items) && data.items.length))) return;
                var item = data.items ? data.items[0] : data;
                document.dispatchEvent(new CustomEvent('atelier:added-to-cart', {
                  detail: {
                    variantId: item.variant_id || item.id || null,
                    quantity: item.quantity || 1,
                    title: item.product_title || item.title || null,
                    value: (typeof item.price === 'number') ? (item.price / 100) * (item.quantity || 1) : undefined
                  }
                }));
              } catch (e) { /* 桥接失败绝不影响加购本身 */ }
            });
          console.log('Email popup: madeova ATC bridge installed (jQuery ajaxSuccess -> atelier:added-to-cart)');
          return;
        }
        if (attempt >= 25) {
          console.warn('Email popup: jQuery 未就绪，加购桥接未安装（弹窗不会自动触发）');
          return;
        }
        setTimeout(function () { installAtcBridge(attempt + 1); }, 200);
      })(0);

      console.log('Email popup: add-to-cart listeners initialized (custom event + fetch hook, throttled)');
    }
    
    // 结账页面自动填充优惠码（备用方案）
    function autoApplyDiscountAtCheckout() {
      if (window.location.pathname.indexOf('/checkout') !== -1 || 
          window.location.pathname.indexOf('/checkouts/') !== -1) {
        
        if (!hasDiscount()) {
          return;
        }
        
        var tryApply = function() {
          // 查找优惠码输入框并填充
          var discountInput = document.querySelector('input[name="discount"], input[placeholder*="discount" i], input[placeholder*="promo" i], input[placeholder*="coupon" i]');
          
          if (discountInput) {
            discountInput.value = DISCOUNT_CODE;
            discountInput.dispatchEvent(new Event('input', { bubbles: true }));
            discountInput.dispatchEvent(new Event('change', { bubbles: true }));
            
            var applyBtn = discountInput.closest('form') ? 
              discountInput.closest('form').querySelector('button[type="submit"], input[type="submit"]') : null;
            if (applyBtn) {
              setTimeout(function() {
                applyBtn.click();
              }, 500);
            }
            return true;
          }
          
          // Shopify结账页面的优惠码字段
          var shopifyDiscountInput = document.querySelector('.discount__input input, .field__input[name="discount"], [data-discount-input]');
          if (shopifyDiscountInput) {
            shopifyDiscountInput.value = DISCOUNT_CODE;
            shopifyDiscountInput.dispatchEvent(new Event('input', { bubbles: true }));
            
            var shopifyApplyBtn = document.querySelector('.discount__button button, [data-discount-button]');
            if (shopifyApplyBtn) {
              setTimeout(function() {
                shopifyApplyBtn.click();
              }, 500);
            }
            return true;
          }
          
          return false;
        };
        
        if (!tryApply()) {
          var observer = new MutationObserver(function() {
            if (tryApply()) {
              observer.disconnect();
            }
          });
          observer.observe(document.body, { childList: true, subtree: true });
          
          setTimeout(function() {
            observer.disconnect();
          }, 10000);
        }
      }
    }
    
    // 安全初始化函数（包裹在try-catch中）
    // ATC-DEDUPE 2026-09-18：本函数此前**没有幂等守卫**，而下方有三条调用路径
    //（initPopup 的 setTimeout、window.load 兜底、delayedInit），实际被执行两次 →
    // initAddToCartListener() 注册了 2 个 atelier:added-to-cart 监听器 →
    // 一次加购上报 2 次 FB AddToCart。生产实测：一次真实加购 = 8 次 AddToCart。
    // 现在无论被调用多少次都只会真正初始化一次。
    var __emailPopupSafeInitDone = false;
    function safeInit() {
      if (__emailPopupSafeInitDone) return;
      __emailPopupSafeInitDone = true;
      try {
        // 检查必要的DOM元素是否存在
        if (!overlay || !form) {
          console.log('Email popup: required elements not found, skipping init');
          return;
        }
        // 页面加载时强制隐藏Toast，确保不会显示绿色模块
        if (toast) {
          toast.classList.remove('show');
          toast.style.display = 'none';
          toast.style.opacity = '0';
          toast.style.visibility = 'hidden';
          console.log('Email popup: Toast force hidden on page load');
        }
        initAddToCartListener();
        autoApplyDiscountAtCheckout();
        console.log('Email popup: initialized successfully');
      } catch(e) {
        console.error('Email popup init error:', e);
      }
    }
    
    // 延迟初始化（等待页面其他脚本先执行完成，避免影响主图）
    function delayedInit() {
      if (document.readyState === 'complete') {
        // 页面完全加载后，再延迟500ms执行
        setTimeout(safeInit, 500);
      } else {
        document.addEventListener('load', function() {
          setTimeout(safeInit, 500);
        });
      }
    }
    
    // 启动初始化 - 使用DOMContentLoaded更快，同时保留load作为备用
    function initPopup() {
      setTimeout(safeInit, 300);
    }
    
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      initPopup();
    } else {
      document.addEventListener('DOMContentLoaded', initPopup);
    }
    
    // 备用：load事件也初始化一次（确保不会错过）
    window.addEventListener('load', function() {
      setTimeout(function() {
        // 检查是否已经初始化过
        if (!window._emailPopupInitialized) {
          window._emailPopupInitialized = true;
          safeInit();
        }
      }, 500);
    });
    
  })();
